import { Navigate } from 'react-router-dom'

const Authenticate = () => {
    return <Navigate to="/" replace />
}

export default Authenticate
